// The v2 profile `external_id` server field name, duplicated here to keep the
// shared User layer from importing the Inhabitant edit modal.
export const USER_PROFILE_HEADER_EDIT_SUBMIT_EXTERNAL_ID_ERROR_KEY =
  'external_id'
